document.addEventListener("DOMContentLoaded", function () {
    const forminput = document.getElementById("sellingplanid");
    const selectElement = document.getElementById('sub_widget_select');
    const default_value = document.getElementById("default_sub_widget").value;
    const radioButtons = document.querySelectorAll('input[type="radio"][name="option"]');
    const modaleSubscription = document.getElementById('modale_subscription');
    const informationblock = document.getElementById("informationbutton");
    const informationbutton = document.getElementById("hover-div");
    const xbutton = document.querySelector('.close_info_sub');
    console.log(forminput);
    console.log(default_value);
    forminput.value = default_value;

    informationbutton.addEventListener("click", openinfo);

    xbutton.addEventListener("click", function (e) {
        informationblock.style.display = "none";
        document.documentElement.classList.remove("js-drawer-open");
        document.documentElement.style.overflow = "auto";
    });

    document.addEventListener("click", function (event) {
        if (event.target === document.body) {
            informationblock.style.display = "none";
            document.documentElement.classList.remove("js-drawer-open");
            document.documentElement.style.overflow = "auto";
        }
    });

    document.addEventListener('variant:change', updateDisplayedPrices);

    selectElement.addEventListener('change', handleselectChange);

    radioButtons.forEach(radio => {
        radio.addEventListener('change', function (event) {
            if (this.checked) {
                if(this.value == "nosub"){
                    forminput.value = "";
                    modaleSubscription.selectedIndex = 0;
                    modaleSubscription.classList.remove('no-border');
                }
                else{
                    forminput.value = selectElement.value;
                    modaleSubscription.value = selectElement.value;
                    modaleSubscription.classList.add('no-border');
                }
            }
        });
    });
    function openinfo() {
        informationblock.style.display = "block";
        document.documentElement.classList.add("js-drawer-open");
        document.documentElement.style.overflow = "hidden";
    }
    function handleselectChange(event) {
        forminput.value = event.target.value;
        modaleSubscription.value = event.target.value;
    }
    function updateDisplayedPrices(event) {
        const variant = event.detail.variant;
        if (!variant) return;

        const moneyFormat = theme.settings.moneyFormat || "${{amount}}";

        const formatMoney = (amount) => {
            return theme.Currency.formatMoney(amount, moneyFormat);
        };

        const priceRegular = document.querySelector('.price-regular');
        if (priceRegular) priceRegular.innerHTML = formatMoney(variant.price);

        const priceCompare = document.querySelector('.price-compare');
        if (priceCompare) {
            priceCompare.innerHTML = formatMoney(variant.compare_at_price);
        }

        const priceDiscounted = document.querySelector('.price-discounted');
        if (priceDiscounted) {
            const discounted = Math.round(variant.price * 0.85);
            priceDiscounted.innerHTML = formatMoney(discounted);
        }
    }


});
